// extracted by mini-css-extract-plugin
export var change = "_3o-1";
export var changeList = "_3o-0";
export var changePath = "_3o-2";
export var diffArrow = "_3o-5";
export var diffRow = "_3o-3";
export var diffValue = "_3o-4";
export var error = "_3o-8";
export var notice = "_3o-9";
export var result = "_3o-6";
export var success = "_3o-7";